'use strict';

export const getSiteLocation = () => {
    const $page = $('.page');
    const action = $page.data('action');
    switch (action) {
        case 'Home-Show':
            return 'home';
        case 'Search-Show':
            return $page.data('querystring').includes('cgid=') ? 'product list page' : 'search page';
        case 'Product-Show':
            return 'product detail page';
        default:
            return 'editorial';
    }
};